import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import SidebarCajero from './SidebarCajero';
import '../../styles/layout.css'; // mismo estilo que admin/mozo

const CajeroLayout = () => {
  const { slug } = useParams();

  return (
    <div className="layout-wrapper">
      <SidebarCajero slug={slug} />
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default CajeroLayout;
